module.exports = __webpack_public_path__ + "media/base/edit-9238c313.svg";